import React from 'react';
import { Link } from 'react-router-dom';

function PriceCard(props) {
    const handleClick = (e) => {
        e.preventDefault(); // Prevent default navigation
        if (props.onClick) {
            props.onClick();
        }
    };

    return (
        <>
        <li className='cards__item'>
            <Link className='cards__item__link' to={props.path || '#'} onClick={handleClick}>
                 {/*<figure className='cards__item__pic-wrap' data-category={props.label}>
                    <img src={props.src} alt='Travel Image' 
                    className='cards__item__img'/>
                </figure>*/}
                <div className='cards__item__info'>
                    <h3 className='cards__item__header'>{props.header}</h3>
                    
                    <div className='cards__item__price'>
                        <span className='currency'>{props.price}</span>
                        <span className='per-month'>SEK/month</span>
                    </div>
                    <h5 className='cards__item__text'>{props.text}</h5>
                    <p className='cards__item__undertext'>{props.undertext}</p>
                    <div className='cards__item__features'>
                        <ul>
                            {props.features.map((feature, index) => (
                                <li key={index}>
                                    <ion-icon name="checkmark-outline"></ion-icon>{feature}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </Link>
        </li>
        </>
    );
}

export default PriceCard;